export default __webpack_public_path__ + "static/media/pbi6.ad096620.JPG";